import React, { useState, useContext, useEffect } from 'react';
import { Box, Typography, Switch, Divider, Tooltip, Link } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import itemShareStyle from './ItemShare.style';
import {
	OKAY,
	LEARN_MORE,
	ITEM_SHARE,
	ITEM_ACCESS_TYPE,
	ITEM_SHARE_SELECTION,
	VARIANT_ATTRIBUTE_ITEM_SHARE_CONFIRM,
	VARIANT_ATTRIBUTE_ITEM_SHARE_MESSAGE
} from 'constants/constant';
import { useSelector, useDispatch } from 'react-redux';
import { UserPortalContext } from 'context/appcontext';
import { saveItemShareStatus, setSelectedList, addPreviewColumn } from '../Preview/Preview.actions';
import { isVariantAttrInTheList, isVariantIDInTheList } from 'components/Preview/Preview.utils';
import ItemShareTnCDialog from './ItemShareTnCDialog';
import VariantAttributeDialog from 'components/Shared/DialogBox';
import { deepClone, isObjEmpty } from 'helper/helper';
import { getTmplName, isCustomDataset } from 'helper/utils';
import { saveItemShareMandatorySelection } from '../Preview/Preview.actions';
import { colors } from 'theme/color-palette';
const { DARK_PURPLE } = colors;

function ItemShare(props) {
	const portalUserContext = useContext(UserPortalContext);
	const dispatch = useDispatch();
	const { isItemShareAccepted } = portalUserContext;
	const {
		divider = false,
		tooltipPosition = 'bottom',
		setSelectedListCount = {},
		selectedListCount = {}
	} = props;
	const { templateData } = useSelector((state) => state.templateReducer);
	const { itemShareStatus } = useSelector((state) => state.previewReducer);
	const previewData = useSelector((state) => state.previewReducer.previewData);
	const { selectedList, filterList } = useSelector((state) => state.previewReducer);
	const templateId = useSelector((state) => state.templateReducer.selectedTemplate);
	const mandatorySelection = useSelector((state) => state.previewReducer.mandatorySelection);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const result = isCustomDataset(templateId)
		? { ...customDatasetDetails }
		: [...templateData, ...cannedReportData].filter(
				(item) => item.templateName === getTmplName(templateId)
		  )[0];

	const [enableItemShare, setEnableItemShare] = useState(false);
	const [showTermsCondition, setShowTermsCondition] = useState(false);
	const [showVariantAttributeDialog, setShowVariantAttributeDialog] = useState(false);
	const variantAttrISFlag = JSON.parse(localStorage.getItem(VARIANT_ATTRIBUTE_ITEM_SHARE_CONFIRM));

	const classes = itemShareStyle();

	useEffect(() => {
		/** if item share enabled for this template */
		if (selectedTemplate !== null) {
			if (result.itemShare) {
				let itemShareMandatorySelections = result.dimensions.find(
					(item) => item.businessName === ITEM_ACCESS_TYPE
				);
				itemShareMandatorySelections = { ...itemShareMandatorySelections, parent: 'dimensions' };
				dispatch(saveItemShareMandatorySelection(itemShareMandatorySelections));
			}
		}
	}, []);

	useEffect(() => {
		setEnableItemShare(itemShareStatus.curr);
	}, [itemShareStatus]);

	useEffect(() => {
		const showDialog = itemShareStatus.curr && !variantAttrISFlag;
		if (showDialog && (isVariantAttrInTheList(selectedList) || isVariantIDInTheList(filterList))) {
			setShowVariantAttributeDialog(true);
		}
	}, [selectedList, filterList, itemShareStatus]);

	const getTooltipTxt = () => {
		return (
			<Box className={classes.tooltipPanel}>
				<Typography className={classes.tooltipText}>{ITEM_SHARE.ITEM_SHARE_INFO}</Typography>
				<Link
					href={ITEM_SHARE.ITEM_SHARE_INFO_LINK}
					target="_blank"
					className={classes.underlineText}
					style={{ textDecoration: 'none', color: DARK_PURPLE, fontStyle: 'italic' }}>
					{LEARN_MORE}
				</Link>
				<Typography className={classes.tooltipText}>{ITEM_SHARE.ABOUT}</Typography>
				<Typography className={classes.tooltipText}>{ITEM_SHARE.FEATURE_NAME}</Typography>
			</Box>
		);
	};

	/**
	 * Inc/dec counter
	 */

	const decCounter = () => {
		const counters = deepClone(selectedListCount);
		counters['Item Info and Item hierarchy']--;
		setSelectedListCount(counters);
	};

	const incCounter = (count) => {
		const counters = deepClone(selectedListCount);
		counters['Item Info and Item hierarchy'] = counters['Item Info and Item hierarchy'] + count;
		setSelectedListCount(counters);
	};

	const addMandatorySelection = () => {
		/**
		 * Checking if item share specific attr available in selected list
		 */
		const itemShareSpecificAttr = selectedList.some((el) => {
			if (ITEM_SHARE_SELECTION.includes(el.businessName)) {
				return el;
			}
		});

		/**
		 * Checking ITEM ACCESS TYPE is available or not in selected list
		 */
		const itemAccObj = selectedList.find((el) => el.businessName === ITEM_ACCESS_TYPE);

		/**
		 * itemAccObj will be added only if WM item number or Catalog id or both is there
		 */
		if (itemShareSpecificAttr && !itemAccObj) {
			dispatch(addPreviewColumn(previewData, mandatorySelection.technicalName));

			/** Inc counter as item access type added */
			if (!isObjEmpty(selectedListCount)) {
				incCounter(1);
			}

			let _selList = deepClone(selectedList);
			_selList = [..._selList, mandatorySelection];
			dispatch(setSelectedList(_selList));
		}
	};

	/**
	 * Remove filter which are specfic to item share if toggle OFF
	 */
	const removeMandatorySelection = () => {
		let _selList = deepClone(selectedList);

		/** if item share specific attributed selected */
		const isItemShareAttrPresent = _selList.some((item) => item.businessName === ITEM_ACCESS_TYPE);

		_selList = _selList.filter((el) => el.businessName !== ITEM_ACCESS_TYPE);

		if (isItemShareAttrPresent) {
			decCounter();
		}

		dispatch(setSelectedList(_selList));
	};

	if (!result?.itemShare) {
		//itemShare
		return null;
	}

	const lockToggleOperation = () =>
		isVariantAttrInTheList(selectedList) || isVariantIDInTheList(filterList);

	const acknowledgVariantAttribute = () => {
		setShowVariantAttributeDialog(!showVariantAttributeDialog);
		localStorage.setItem(VARIANT_ATTRIBUTE_ITEM_SHARE_CONFIRM, true);
	};

	return (
		<Box style={{ display: 'flex', alignItems: 'center' }} id="item-share-switch">
			<Switch
				checked={enableItemShare}
				onChange={(event) => {
					const isChecked = event.target.checked;
					// If user has selected any Variant attributes[DSIDVL-23290],
					// Item share will be in the ON state, and toggle operation should be locked
					if (!isChecked && lockToggleOperation()) {
						return;
					}
					if (!isItemShareAccepted) {
						setShowTermsCondition(true);
						return;
					}
					setEnableItemShare((prev) => !prev);
					dispatch(saveItemShareStatus({ curr: isChecked }));

					if (isChecked) {
						addMandatorySelection();
					} else {
						removeMandatorySelection();
					}
				}}
				color="primary"
				name="item-share"
				inputProps={{ 'aria-label': 'primary checkbox' }}
			/>
			<Typography>{ITEM_SHARE.FEATURE_NAME}</Typography>
			<Tooltip
				title={getTooltipTxt()}
				arrow
				style={{ maxWidth: '100px' }}
				leaveDelay={2000}
				placement={tooltipPosition}
				clickable>
				<InfoOutlinedIcon
					style={{ color: '#6D6E71', marginLeft: 16, paddingTop: 1 }}
					fontSize="small"
					data-testid="info-icon"
				/>
			</Tooltip>

			{divider && (
				<Divider
					orientation={'vertical'}
					flexItem={true}
					style={{ marginLeft: 16, marginRight: 16, backgroundColor: '#DADCE0' }}
				/>
			)}
			{/* Show the message when variant attributes added to the selected list */}
			<VariantAttributeDialog
				hideTitle
				hidePrimaryBtn
				primaryBtnText={OKAY}
				open={showVariantAttributeDialog}
				onPrimaryClick={acknowledgVariantAttribute}
				bodyContent={VARIANT_ATTRIBUTE_ITEM_SHARE_MESSAGE}
			/>
			<ItemShareTnCDialog
				open={showTermsCondition}
				onClose={({ status }) => {
					if (status === 'ACCEPTED') {
						dispatch(saveItemShareStatus({ curr: true }));
						setEnableItemShare(true);
						addMandatorySelection();
					} else {
						setEnableItemShare(false);
					}
					setShowTermsCondition(false);
				}}
			/>
		</Box>
	);
}

export default ItemShare;
